<div class="h-screen flex flex-col bg-card">
    <div class="flex-grow">
        <!-- Loading bar -->
        <fuse-loading-bar></fuse-loading-bar>

        <router-outlet></router-outlet>
    </div>
</div>

<hlm-toaster position="top-right" />
